module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v(_vm._s(_vm.title)), (_vm.description) ? _c('span', [_c('v-tooltip', {
    attrs: {
      "tip": _vm.description,
      "pos": _vm.pos
    }
  }, [_c('i', {
    staticClass: "fa fa fa-question-circle"
  })])], 1) : _vm._e(), _c('small', [_vm._v(_vm._s(_vm.dateStr))]), _vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e613c9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e613c9a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/component/general-title.vue
// module id = 734
// module chunks = 0